import React, { useState } from 'react';
import { FaStar, FaQuoteLeft, FaTrophy, FaFire, FaDumbbell } from 'react-icons/fa';

const Testimonials = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const testimonials = [
    {
      id: 1,
      name: 'Rajesh Kumar',
      age: 28,
      goal: 'Weight Loss',
      category: 'weight-loss',
      image: 'https://via.placeholder.com/150',
      rating: 5,
      beforeWeight: '95kg',
      afterWeight: '75kg',
      duration: '6 months',
      review: 'Coach Sabari transformed my life! Lost 20kg and gained confidence. His rugged training methods really work. Best decision I ever made!',
      achievement: 'Lost 20kg in 6 months'
    },
    {
      id: 2,
      name: 'Priya Sharma',
      age: 25,
      goal: 'Muscle Gain',
      category: 'muscle-gain',
      image: 'https://via.placeholder.com/150',
      rating: 5,
      beforeWeight: '52kg',
      afterWeight: '58kg',
      duration: '4 months',
      review: 'Amazing trainer! Helped me gain lean muscle and strength. The personalized workout plans and nutrition guidance were perfect for my goals.',
      achievement: 'Gained 6kg lean muscle'
    },
    {
      id: 3,
      name: 'Arun Patel',
      age: 35,
      goal: 'Strength Training',
      category: 'strength',
      image: 'https://via.placeholder.com/150',
      rating: 5,
      beforeWeight: '78kg',
      afterWeight: '82kg',
      duration: '8 months',
      review: 'Increased my strength dramatically! Deadlift went from 80kg to 140kg. Coach Sabari knows exactly how to push you to your limits safely.',
      achievement: 'Deadlift 140kg'
    },
    {
      id: 4,
      name: 'Meera Reddy',
      age: 30,
      goal: 'Fat Loss',
      category: 'weight-loss',
      image: 'https://via.placeholder.com/150',
      rating: 5,
      beforeWeight: '72kg',
      afterWeight: '60kg',
      duration: '5 months',
      review: 'Lost 12kg and feel amazing! The combination of HIIT workouts and nutrition planning worked perfectly. Highly recommend Coach Sabari!',
      achievement: 'Lost 12kg body fat'
    },
    {
      id: 5,
      name: 'Vikram Singh',
      age: 32,
      goal: 'Body Transformation',
      category: 'transformation',
      image: 'https://via.placeholder.com/150',
      rating: 5,
      beforeWeight: '88kg',
      afterWeight: '78kg',
      duration: '7 months',
      review: 'Complete body transformation! From fat to fit. Coach Sabari\'s motivation and expertise made all the difference. Worth every rupee!',
      achievement: 'Complete transformation'
    },
    {
      id: 6,
      name: 'Sneha Iyer',
      age: 27,
      goal: 'Fitness',
      category: 'general',
      image: 'https://via.placeholder.com/150',
      rating: 5,
      beforeWeight: '65kg',
      afterWeight: '62kg',
      duration: '3 months',
      review: 'Best fitness coach! Improved my overall health and energy levels. The online coaching is very convenient and effective.',
      achievement: 'Improved fitness & energy'
    }
  ];

  const categories = [
    { id: 'all', label: 'All Reviews', icon: FaStar },
    { id: 'weight-loss', label: 'Weight Loss', icon: FaFire },
    { id: 'muscle-gain', label: 'Muscle Gain', icon: FaDumbbell },
    { id: 'transformation', label: 'Transformation', icon: FaTrophy }
  ];

  const filteredTestimonials = activeCategory === 'all' 
    ? testimonials 
    : testimonials.filter(t => t.category === activeCategory);

  return (
    <div className="min-h-screen bg-black py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-yellow-400 uppercase tracking-wide mb-3 sm:mb-4">
            Success Stories
          </h1>
          <p className="text-gray-400 text-base sm:text-lg">
            Real transformations from real people
          </p>
        </div>

        {/* Stats Banner */}
        <div className="bg-gradient-to-r from-yellow-500 via-orange-500 to-red-600 rounded-2xl p-1 mb-8 sm:mb-12">
          <div className="bg-black rounded-2xl p-6 sm:p-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 text-center">
              <div>
                <div className="text-4xl font-bold text-yellow-400 mb-2">2+</div>
                <div className="text-gray-400 text-sm uppercase">Happy Clients</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-orange-400 mb-2">95%</div>
                <div className="text-gray-400 text-sm uppercase">Success Rate</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-red-400 mb-2">20+</div>
                <div className="text-gray-400 text-sm uppercase">KG Lost</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-yellow-400 mb-2">5.0</div>
                <div className="text-gray-400 text-sm uppercase">Average Rating</div>
              </div>
            </div>
          </div>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-8 sm:mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-bold uppercase text-sm tracking-wide transition-all transform hover:scale-105 border-2 ${
                activeCategory === category.id
                  ? 'bg-gradient-to-r from-yellow-500 to-orange-600 text-black border-yellow-400'
                  : 'bg-gray-900 text-gray-300 hover:text-yellow-400 border-gray-700'
              }`}
            >
              <category.icon />
              <span>{category.label}</span>
            </button>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {filteredTestimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gray-900 border-2 border-yellow-500/30 rounded-xl p-6 hover:border-yellow-400 transition-all transform hover:scale-105"
            >
              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center space-x-3">
                  <div className="w-16 h-16 bg-gradient-to-r from-yellow-500 to-orange-600 rounded-full flex items-center justify-center text-black font-bold text-xl">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white">{testimonial.name}</h3>
                    <p className="text-sm text-gray-400">{testimonial.age} years old</p>
                  </div>
                </div>
                <FaQuoteLeft className="text-yellow-500/30 text-2xl" />
              </div>

              {/* Rating */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="text-yellow-400" />
                ))}
              </div>

              {/* Achievement Badge */}
              <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border border-yellow-500/30 rounded-lg p-3 mb-4">
                <div className="text-yellow-400 font-bold text-sm uppercase mb-1">
                  🏆 {testimonial.goal}
                </div>
                <div className="text-white font-bold">{testimonial.achievement}</div>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-2 mb-4">
                <div className="bg-black border border-gray-700 rounded-lg p-2 text-center">
                  <div className="text-xs text-gray-500 uppercase mb-1">Before</div>
                  <div className="text-sm font-bold text-red-400">{testimonial.beforeWeight}</div>
                </div>
                <div className="bg-black border border-gray-700 rounded-lg p-2 text-center">
                  <div className="text-xs text-gray-500 uppercase mb-1">After</div>
                  <div className="text-sm font-bold text-green-400">{testimonial.afterWeight}</div>
                </div>
                <div className="bg-black border border-gray-700 rounded-lg p-2 text-center">
                  <div className="text-xs text-gray-500 uppercase mb-1">Time</div>
                  <div className="text-sm font-bold text-yellow-400">{testimonial.duration}</div>
                </div>
              </div>

              {/* Review */}
              <p className="text-gray-400 text-sm leading-relaxed italic">
                "{testimonial.review}"
              </p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-8 sm:mt-12 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-600 rounded-2xl p-6 sm:p-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-black uppercase tracking-wide mb-3 sm:mb-4">
            Ready to Write Your Success Story?
          </h2>
          <p className="text-gray-900 text-base sm:text-lg mb-4 sm:mb-6">
            Join hundreds of satisfied clients who transformed their lives
          </p>
          <button className="bg-black hover:bg-gray-900 text-yellow-400 px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all transform hover:scale-105 border-2 border-black">
            Start Your Transformation
          </button>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
